import styled from 'styled-components';

// The editor routes size themselves to this box with `height: 100%`, so it has to be a
// definite height rather than a block growing to its content — otherwise the percentage
// resolves to auto and nothing inside can scroll independently. The table/create routes
// overflow it visibly and keep scrolling on the app shell as before.
export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	padding: 2rem 2rem 1rem;
	color: ${(props) => props.theme.v3.colors.dark[8]};
`;
